import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const WorkExperience = () => {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  const experiences = [
    {
      company: "7 Eagles",
      duration: "Aug 2024 – Present",
      role: "Mern Full Stack Developer",
      points: [
        "Engineered a proprietary MERN-stack Task Management Tool, replacing external subscriptions and reducing operational costs.",
        "Awarded Employee of the Month (Feb 2026) for delivering high-impact internal solutions and performance excellence.",
        "Architecting scalable UIs using Next.js, TypeScript, and Tailwind CSS with a focus on optimized rendering.",
        "Implemented secure JWT authentication and role-based access control (RBAC) using Zustand for state management.",
        "Developed interactive data visualizations with Recharts, enhancing internal decision-making workflows.",
      ],
    },
    // {
    //   company: "7 Eagles",
    //   duration: "Sep 2024 – Dec 2024",
    //   role: "MERN Stack Developer Intern",
    //   points: [
    //     "Developed and optimized RESTful APIs using Express.js and MongoDB to streamline data persistence.",
    //     "Built 100% mobile-responsive components using Tailwind CSS and ShadCN UI for cross-device compatibility.",
    //     "Streamlined deployments on AWS EC2 using Nginx reverse proxies and Ubuntu server environments.",
    //   ],
    // },
    {
      company: "Error Makes Clever",
      duration: "July 2024 – Aug 2024",
      role: "Full Stack Development Intern",
      points: [
        "Engineered 'Elite Fitness', a full-stack gym platform which secured 1st Place at the CognoRise Hackathon.",
        "Mastered full-stack workflows using MongoDB, Express, React, and Node.js for scalable web apps.",
        "Collaborated on designing intuitive user journeys and secure backend integrations.",
      ],
    },
    {
      company: "OctaNet Services Pvt Ltd",
      duration: "June 2024 – July 2024",
      role: "Frontend Internship",
      points: [
        "Developed interactive user interfaces using HTML, CSS, and JavaScript for diverse client requirements.",
        "Delivered responsive web projects focusing on performance optimization and cross-browser stability.",
      ],
    },
  ];

  return (
    <motion.section
      id="experience"
      className="bg-black text-white w-full min-h-screen py-16"
      initial={{ opacity: 0 }}
      animate={inView ? { opacity: 1 } : { opacity: 0 }}
      transition={{ duration: 0.5 }}
      ref={ref}
    >
      <div className="max-w-6xl mx-auto px-4 lg:px-12 relative">
        <motion.h2
          className="text-4xl font-bold mb-16 flex justify-center"
          initial={{ y: -50, opacity: 0 }}
          animate={inView ? { y: 0, opacity: 1 } : { y: -50, opacity: 0 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 300, damping: 20 }}
        >
          <span className="border-b-4 border-gray-500">Professional Experience</span>
        </motion.h2>

        <div className="relative border-l-4 border-gray-600 pl-6 ml-3">
          {experiences.map((exp, index) => (
            <motion.div
              key={index}
              className="mb-12 relative"
              initial={{ x: index % 2 === 0 ? -100 : 100, opacity: 0 }}
              animate={inView ? { x: 0, opacity: 1 } : {}}
              transition={{
                delay: 0.3 + index * 0.2,
                type: "spring",
                stiffness: 200,
                damping: 20,
              }}
            >
              <div className="absolute -left-[38px] top-2 w-6 h-6 rounded-full bg-[#F16A6A] shadow-md shadow-[#F16A6A]/50"></div>

              <div className="bg-[#2A2A2A] rounded-xl shadow-xl p-6 hover:scale-[1.02] transition-transform duration-300">
                <h3 className="text-xl font-semibold text-[#F16A6A]">
                  {exp.company}
                </h3>
                <p className="text-sm text-gray-400">{exp.duration}</p>
                <h4 className="text-lg font-medium mt-2">{exp.role}</h4>
                <ul className="list-disc list-inside mt-3 space-y-2 text-gray-300">
                  {exp.points.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default WorkExperience;
